export enum OWF_SECTION_NAME {
  HEADER_CARD = "HEADER_CARD",
  APPLICATION_STATUS = "APPLICATION_STATUS",
  MISSION_STATEMENT = "MISSION_STATEMENT",
  OWF_GRANT_UPSELL = "OWF_GRANT_UPSELL",
  GET_INVENTORY = "GET_INVENTORY",
  MASTER_FUNDAMENTALS = "MASTER_FUNDAMENTALS",
  UPSELL_STATS = "UPSELL_STATS",
  TESTIMONIAL = "TESTIMONIAL",
  FAQ = "FAQ",
  FOOTER_CARD = "FOOTER_CARD",
  PAYMENT_TERMS_UPSELL = "PAYMENT_TERMS_UPSELL",
}
